import { db } from './db'

/**
 * Delete a plan and all of its snapshots in a single transaction.
 * Does NOT touch the underlying ImportedCity — that's a separate operation.
 */
export async function deletePlanCascade(planId: number): Promise<void> {
  await db.transaction('rw', db.plans, db.snapshots, async () => {
    await db.snapshots.where('planId').equals(planId).delete()
    await db.plans.delete(planId)
  })
}

/**
 * Delete an imported city, all of its plans, and all snapshots of those plans.
 * Single transaction — either everything goes or nothing.
 */
export async function deleteImportCascade(importedCityId: number): Promise<void> {
  await db.transaction('rw', db.imports, db.plans, db.snapshots, async () => {
    const planIds = await db.plans
      .where('importedCityId')
      .equals(importedCityId)
      .primaryKeys()

    if (planIds.length > 0) {
      await db.snapshots.where('planId').anyOf(planIds).delete()
      await db.plans.bulkDelete(planIds)
    }
    await db.imports.delete(importedCityId)
  })
}
